module.exports = __webpack_public_path__ + "img/nrl-field.3a0fafb3.png";